import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M10.966 38.5V11.34L0 .44v49.092"
  }), /*#__PURE__*/_jsx("path", {
    d: "M.58 0l10.967 10.966h27.015L49.528 0"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: ".8",
    d: "M11.692 11.7h26.616v26.616H11.692z"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: ".6",
    d: "M39.034 11.5v26.943l10.966 11V.57"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: ".6",
    d: "M38.598 39H11.51L.544 49.966h49.02"
  })]
});